import { render, staticRenderFns } from "./addStaffConnect.vue?vue&type=template&id=2f7c844a&"
import script from "./addStaffConnect.vue?vue&type=script&lang=js&"
export * from "./addStaffConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports